import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import Attachments from '../../../../components/attachments/Attachments/Attachments';
import parentTypes from '../../../../components/attachments/constants/parentTypes';
import roles from '../../constants/roles';
import useUserRoleInDoc from '../../hooks/useUserRoleInDoc';
import { ALLOWED_DOC_ATTACHMENT_FILE_FORMATS as ALLOWED_FILE_FORMATS } from '../../constants/allowedDocAttachmentFileFormats';

const AttachmentsCell = ({ record, needToBeUpdated }) => {
  // const userRole = useUserRoleInDoc(record);
  const workerId = Number(
    useSelector((store) => store.authentication.userInfo.WorkerId)
  );

  // const isAllowedDelete = useCallback(
  //   (file) => file.user.id === workerId,
  //   [workerId]
  // );

  return (
    <Attachments
      needToBeUpdated={needToBeUpdated}
      // isAllowedDeleteThisAttachment={isAllowedDelete}
      hideUploadBox={false}
      parentId={record.id}
      parentType={parentTypes.documents}
      postUrl={`/docs/attach_file/${record.id}`}
      withBorder={false}
      acceptFormats={ALLOWED_FILE_FORMATS}
      allowedDeleteAnyAttachment={false}
    />
  );
};

export default memo(AttachmentsCell);
